import * as React from "react"
import ProductItem from "./ProductItem"
import "./styles.scss"

export default function ProductPassportDataCollapsable({ data, isProductPassportView }) {
    return (
        <div className={`product-data`}>
            {data.map((item, index) => (
                <ProductItem
                    key={`product-item-${index}`}
                    itemData={item}
                    index={index}
                    isProductPassportView={isProductPassportView}
                />
            ))}
        </div>
    )
}
